import React from 'react'
import UiPreviewCanvas from '../components/UiPreviewCanvas'
import addOutlineSrc from '../../../assets/images/Icons/add_outline.svg'
import addFilledSrc from '../../../assets/images/Icons/add_filled.svg'
import multiplyOutlineSrc from '../../../assets/images/Icons/multiply_outline.svg'
import multiplyFilledSrc from '../../../assets/images/Icons/multiply_filled.svg'
import subtractionOutlineSrc from '../../../assets/images/Icons/subtraction_outline.svg'
import subtractionFilledSrc from '../../../assets/images/Icons/subtraction_filled.svg'
import divisionOutlineSrc from '../../../assets/images/Icons/division_outline.svg'
import divisionFilledSrc from '../../../assets/images/Icons/division_filled.svg'
import Arrow2UpSrc from '../../../assets/images/Icons/Arrow_2_up.svg'
import Arrow2DownSrc from '../../../assets/images/Icons/Arrow_2_down.svg'
import Arrow2LeftSrc from '../../../assets/images/Icons/Arrow_2_left.svg'
import Arrow2RightSrc from '../../../assets/images/Icons/Arrow_2_right.svg'
import Arrow3UpSrc from '../../../assets/images/Icons/Arrow_3_up.svg'
import Arrow3DownSrc from '../../../assets/images/Icons/Arrow_3_down.svg'
import Arrow3LeftSrc from '../../../assets/images/Icons/Arrow_3_left.svg'
import Arrow3RightSrc from '../../../assets/images/Icons/Arrow_3_right.svg'
import Arrow3RightUpSrc from '../../../assets/images/Icons/Arrow_3_right_up.svg'
import Arrow3RightDownSrc from '../../../assets/images/Icons/Arrow_3_right_down.svg'
import Arrow3LeftUpSrc from '../../../assets/images/Icons/Arrow_3_left_up.svg'
import Arrow3LeftDownSrc from '../../../assets/images/Icons/Arrow_3_left_down.svg'
import IndentLeftSrc from '../../../assets/images/Icons/Indent_left.svg'
import IndentRightSrc from '../../../assets/images/Icons/Indent_right.svg'
import ArrowsUpSrc from '../../../assets/images/Icons/Arrows_up.svg'
import ArrowsDownSrc from '../../../assets/images/Icons/Arrows_down.svg'
import ArrowsLeftSrc from '../../../assets/images/Icons/Arrows_left.svg'
import ArrowsUpDownSrc from '../../../assets/images/Icons/Arrows_up_down.svg'
import ArrowsRightSrc from '../../../assets/images/Icons/Arrows_right.svg'
import ArrowCircleUpSrc from '../../../assets/images/Icons/Arrow_circle_up.svg'
import ArrowCircleDownSrc from '../../../assets/images/Icons/Arrow_circle_down.svg'
import ArrowCircleLeftSrc from '../../../assets/images/Icons/Arrow_circle_left.svg'
import ArrowCircleRightSrc from '../../../assets/images/Icons/Arrow_circle_right.svg'
import ArrowCircleTopRightSrc from '../../../assets/images/Icons/Arrow_circle_top_right.svg'
import ArrowCircleBottomRightSrc from '../../../assets/images/Icons/Arrow_circle_bottom_right.svg'
import ArrowCircleBottomLeftSrc from '../../../assets/images/Icons/Arrow_circle_bottom_left.svg'
import ArrowCircleTopLeftSrc from '../../../assets/images/Icons/Arrow_circle_top_left.svg'
import RefreshCwSrc from '../../../assets/images/Icons/Refresh_CW.svg'
import RefreshCcwSrc from '../../../assets/images/Icons/Refresh_CCW.svg'
import ReplaceSrc from '../../../assets/images/Icons/Replace.svg'
import NextSrc from '../../../assets/images/Icons/Next.svg'
import BackSrc from '../../../assets/images/Icons/Back.svg'
import Back2Src from '../../../assets/images/Icons/Back_2.svg'
import Back3Src from '../../../assets/images/Icons/Back_3.svg'
import Next2Src from '../../../assets/images/Icons/Next_2.svg'
import Next3Src from '../../../assets/images/Icons/Next_3.svg'
import InfoSrc from '../../../assets/images/Icons/Info.svg'
import AttentionSrc from '../../../assets/images/Icons/Attention.svg'
import AlertSrc from '../../../assets/images/Icons/Alert.svg'
import SearchSrc from '../../../assets/images/Icons/Search.svg'
import LocationSrc from '../../../assets/images/Icons/Location.svg'
import AddScheduleSrc from '../../../assets/images/Icons/Add_schedule.svg'
import ScheduleSrc from '../../../assets/images/Icons/Schedule.svg'
import Schedule2Src from '../../../assets/images/Icons/Schedule2.svg'
import SchedulerSrc from '../../../assets/images/Icons/Scheduler.svg'
import PreviousCalendarSrc from '../../../assets/images/Icons/Previous_calendar.svg'
import UpcomingCalendarSrc from '../../../assets/images/Icons/Upcoming_calendar.svg'
import CalendarSrc from '../../../assets/images/Icons/Calendar.svg'
import AddScheduleOtlSrc from '../../../assets/images/Icons/Add_schedule_otl.svg'
import ScheduleOtlSrc from '../../../assets/images/Icons/Schedule_otl.svg'
import PreviousCalendarOtlSrc from '../../../assets/images/Icons/Previous_calendar_otl.svg'
import UpcomingCalendarOtlSrc from '../../../assets/images/Icons/Upcoming_calendar_otl.svg'
import CalendarOtlSrc from '../../../assets/images/Icons/Calendar_otl.svg'
import CloseSrc from '../../../assets/images/Icons/Close.svg'
import CheckmarkSrc from '../../../assets/images/Icons/Checkmark.svg'
import Checkmark2Src from '../../../assets/images/Icons/Checkmark2.svg'
import Checkmark2OtlSrc from '../../../assets/images/Icons/Checkmark2_otl.svg'
import CheckInSrc from '../../../assets/images/Icons/Check_in.svg'
import CheckOutSrc from '../../../assets/images/Icons/Check_out.svg'
import InTreatmentSrc from '../../../assets/images/Icons/In_treatment.svg'
import InTreatmentAiSrc from '../../../assets/images/Icons/In_treatment_ai.svg'
import InTreatment2Src from '../../../assets/images/Icons/InTreatment2.svg'
import StethoscopeSrc from '../../../assets/images/Icons/Stethoscope.svg'
import LabSrc from '../../../assets/images/Icons/Lab.svg'
import SettingsSrc from '../../../assets/images/Icons/Settings.svg'
import TweakSrc from '../../../assets/images/Icons/Tweak.svg'
import NotificationsSrc from '../../../assets/images/Icons/Notifications.svg'
import FileSrc from '../../../assets/images/Icons/File.svg'
import DocumentSrc from '../../../assets/images/Icons/Document.svg'
import Document2Src from '../../../assets/images/Icons/Document2.svg'
import DotSrc from '../../../assets/images/Icons/Dot.svg'
import DragSrc from '../../../assets/images/Icons/Drag.svg'
import More1Src from '../../../assets/images/Icons/More1.svg'
import More2Src from '../../../assets/images/Icons/More2.svg'
import Delete1Src from '../../../assets/images/Icons/Delete1.svg'
import Delete2Src from '../../../assets/images/Icons/Delete2.svg'
import EditSrc from '../../../assets/images/Icons/Edit.svg'
import CopySrc from '../../../assets/images/Icons/Copy.svg'
import DuplicateSrc from '../../../assets/images/Icons/Duplicate.svg'
import GridSrc from '../../../assets/images/Icons/Grid.svg'
import EmojiSmileSrc from '../../../assets/images/Icons/Emoji_smile.svg'
import CallCheckSrc from '../../../assets/images/Icons/Call_check.svg'
import SortSrc from '../../../assets/images/Icons/Sort.svg'
import Add2Src from '../../../assets/images/Icons/Add_2.svg'
import MoveToSrc from '../../../assets/images/Icons/Move_to.svg'
import MoveToFolderSrc from '../../../assets/images/Icons/Move_to_folder.svg'
import MoveToFolder2Src from '../../../assets/images/Icons/Move_to_folder_2.svg'
import Print2Src from '../../../assets/images/Icons/Print2.svg'
import Print1Src from '../../../assets/images/Icons/Print1.svg'
import PinSrc from '../../../assets/images/Icons/Pin.svg'
import DownloadSrc from '../../../assets/images/Icons/Download.svg'
import AudioPlayerPlaySrc from '../../../assets/images/Icons/Audio_player_play.svg'
import AudioPlayerPauseSrc from '../../../assets/images/Icons/Audio_player_pause.svg'
import AudioPlayerPlay2Src from '../../../assets/images/Icons/Audio_player_play_2.svg'
import AudioPlayerPause2Src from '../../../assets/images/Icons/Audio_player_pause_2.svg'
import AudioPlayerBack10Src from '../../../assets/images/Icons/Audio_player_back_10.svg'
import AudioPlayerForward10Src from '../../../assets/images/Icons/Audio_player_forward_10.svg'
import AudioPlayerVolumeSrc from '../../../assets/images/Icons/Audio_player_volume.svg'
import AudioPlayerVolumeMuteSrc from '../../../assets/images/Icons/Audio_player_volume_mute.svg'
import ViewSrc from '../../../assets/images/Icons/View.svg'
import HideSrc from '../../../assets/images/Icons/Hide.svg'
import CameraSrc from '../../../assets/images/Icons/Camera.svg'
import RecordSrc from '../../../assets/images/Icons/Record.svg'
import CallSrc from '../../../assets/images/Icons/Call.svg'
import ArrowMissedCallSrc from '../../../assets/images/Icons/Arrow_missed_call.svg'
import ArrowDeclinedSrc from '../../../assets/images/Icons/Arrow_declined.svg'
import MessageSrc from '../../../assets/images/Icons/Message.svg'
import SendInAdvance2Src from '../../../assets/images/Icons/Send_in_advance_2.svg'
import MailFillSrc from '../../../assets/images/Icons/Mail_fill.svg'
import MailLineSrc from '../../../assets/images/Icons/Mail_line.svg'
import MailOpenFillSrc from '../../../assets/images/Icons/Mail_open_fill.svg'
import MailOpenLineSrc from '../../../assets/images/Icons/Mail_open_line.svg'
import FaxSrc from '../../../assets/images/Icons/Fax.svg'
import InboxSrc from '../../../assets/images/Icons/Inbox.svg'
import ArchiveSrc from '../../../assets/images/Icons/Archive.svg'
import AttachmentSrc from '../../../assets/images/Icons/Attachment.svg'
import SentSrc from '../../../assets/images/Icons/Sent.svg'
import SendSrc from '../../../assets/images/Icons/Send.svg'
import SendInAdvanceSrc from '../../../assets/images/Icons/Send_in_advance.svg'
import BlockedSrc from '../../../assets/images/Icons/Blocked.svg'
import DraftsSrc from '../../../assets/images/Icons/Drafts.svg'
import FolderSrc from '../../../assets/images/Icons/Folder.svg'
import TagSrc from '../../../assets/images/Icons/Tag.svg'
import ClockSrc from '../../../assets/images/Icons/Clock.svg'
import Clock2Src from '../../../assets/images/Icons/Clock2.svg'
import MoneySrc from '../../../assets/images/Icons/Money.svg'
import Money2Src from '../../../assets/images/Icons/Money2.svg'
import DollarSrc from '../../../assets/images/Icons/Dollar.svg'
import AdjustmentSrc from '../../../assets/images/Icons/Adjustment.svg'
import ClaimsSrc from '../../../assets/images/Icons/Claims.svg'
import ShieldSrc from '../../../assets/images/Icons/Shield.svg'
import ShieldOutlineSrc from '../../../assets/images/Icons/Shield_outline.svg'
import InsuranceVerifiedSrc from '../../../assets/images/Icons/Insurance_verified.svg'
import InsurancePlusSrc from '../../../assets/images/Icons/Insurance_plus.svg'
import InsuranceUnverifiedSrc from '../../../assets/images/Icons/Insurance_unverified.svg'
import InsuranceExpiredSrc from '../../../assets/images/Icons/Insurance_expired.svg'
import InsuranceInfoSrc from '../../../assets/images/Icons/Insurance_info.svg'
import InsuranceModuleSrc from '../../../assets/images/Icons/Insurance_module.svg'
import UserAvatarSrc from '../../../assets/images/Icons/User_avatar.svg'
import AvatarClockSrc from '../../../assets/images/Icons/Avatar_clock.svg'
import AvatarUserInfoSrc from '../../../assets/images/Icons/Avatar_user_info.svg'
import AddUserAvatarSrc from '../../../assets/images/Icons/Add_user_avatar.svg'
import AddGroupAvatarSrc from '../../../assets/images/Icons/Add_group_avatar.svg'
import AttendanceSrc from '../../../assets/images/Icons/Attendance.svg'
import AvatarBlockedSrc from '../../../assets/images/Icons/Avatar_blocked.svg'
import TxPlanSrc from '../../../assets/images/Icons/Tx_plan.svg'
import TxPlan2Src from '../../../assets/images/Icons/Tx_plan2.svg'
import PatientInfoSrc from '../../../assets/images/Icons/Patient_info.svg'
import FilesSrc from '../../../assets/images/Icons/Files.svg'
import File2Src from '../../../assets/images/Icons/File_2.svg'
import FilesPdfSrc from '../../../assets/images/Icons/Files_pdf.svg'
import WalletSrc from '../../../assets/images/Icons/Wallet.svg'
import Collect1Src from '../../../assets/images/Icons/Collect1.svg'
import Collect2Src from '../../../assets/images/Icons/Collect2.svg'
import MaleSrc from '../../../assets/images/Icons/Male.svg'
import FemaleSrc from '../../../assets/images/Icons/Female.svg'
import HealthConditionSrc from '../../../assets/images/Icons/Health_condition.svg'
import AllergiesSrc from '../../../assets/images/Icons/Allergies.svg'
import AttentionRequiredSrc from '../../../assets/images/Icons/Attention_required.svg'
import HealthSrc from '../../../assets/images/Icons/Health.svg'
import Star1Src from '../../../assets/images/Icons/Star1.svg'
import Star2Src from '../../../assets/images/Icons/Star2.svg'
import FormCompletedSrc from '../../../assets/images/Icons/Form_completed.svg'
import FormIncompleteSrc from '../../../assets/images/Icons/Form_incomplete.svg'
import FormBuilderSrc from '../../../assets/images/Icons/Form_builder.svg'
import MissedPaymentsSrc from '../../../assets/images/Icons/Missed_payments.svg'
import MedicalTestSrc from '../../../assets/images/Icons/Medical_test.svg'
import HealthTestSrc from '../../../assets/images/Icons/Health_test.svg'
import RecurringSrc from '../../../assets/images/Icons/Recurring.svg'
import BoldSrc from '../../../assets/images/Icons/Bold.svg'
import ItalicSrc from '../../../assets/images/Icons/Italic.svg'
import UnderlineSrc from '../../../assets/images/Icons/Underline.svg'
import StrikethroughSrc from '../../../assets/images/Icons/Strikethrough.svg'
import BgColorSrc from '../../../assets/images/Icons/Bg_color.svg'
import TextColorSrc from '../../../assets/images/Icons/Text_color.svg'
import LinkSrc from '../../../assets/images/Icons/Link.svg'
import SignatureSrc from '../../../assets/images/Icons/Signature.svg'
import AlignLeftSrc from '../../../assets/images/Icons/Align_left.svg'
import AlignRightSrc from '../../../assets/images/Icons/Align_right.svg'
import AlignCenterSrc from '../../../assets/images/Icons/Align_center.svg'
import AlignJustifySrc from '../../../assets/images/Icons/Align_justify.svg'
import RefineSrc from '../../../assets/images/Icons/Refine.svg'
import WriteAiSrc from '../../../assets/images/Icons/Write_ai.svg'
import AiWandSrc from '../../../assets/images/Icons/Ai_wand.svg'
import VariableSrc from '../../../assets/images/Icons/Variable.svg'
import EnumerateSrc from '../../../assets/images/Icons/Enumerate.svg'
import ListSrc from '../../../assets/images/Icons/List.svg'
import BlockquoteSrc from '../../../assets/images/Icons/Blockquote.svg'
import FilesLettersSrc from '../../../assets/images/Icons/Files_letters.svg'
import NotesSrc from '../../../assets/images/Icons/Notes.svg'
import ChartingSrc from '../../../assets/images/Icons/Charting.svg'
import ImageViewerSrc from '../../../assets/images/Icons/Image_viewer.svg'
import StaffSrc from '../../../assets/images/Icons/Staff.svg'
import CommunicationsSrc from '../../../assets/images/Icons/Communications.svg'
import BillingSrc from '../../../assets/images/Icons/Billing.svg'
import MembershipSrc from '../../../assets/images/Icons/Membership.svg'
import ReportingSrc from '../../../assets/images/Icons/Reporting.svg'
import CampaignSrc from '../../../assets/images/Icons/Campaign.svg'
import { ReactComponent as DashboardIcon } from '../../../assets/images/Icons/Dashboard.svg'
import HistorySrc from '../../../assets/images/Icons/History.svg'
import RequestSrc from '../../../assets/images/Icons/Request.svg'
import './IconsShowcase.css'

type IconShowcaseEntry = {
  id: string
  label: string
  src?: string
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>
}

const IconsShowcase: React.FC = () => (
  <UiPreviewCanvas
    title="Icons"
    description="System icons and usage guidelines."
    stageClassName="ui-preview__stage--narrow icons-showcase__stage-wrap"
  >
    <div className="icons-showcase__sheet">
      {[
        {
          id: 'operations',
          title: 'Operations',
          icons: [
            { id: 'add_outline', label: 'Add_outline', src: addOutlineSrc },
            { id: 'add_filled', label: 'Add', src: addFilledSrc },
            { id: 'add_2', label: 'Add_2', src: Add2Src },
            {
              id: 'multiply_outline',
              label: 'Multiply_outline',
              src: multiplyOutlineSrc,
            },
            {
              id: 'multiply_filled',
              label: 'Multiply',
              src: multiplyFilledSrc,
            },
            {
              id: 'subtraction_outline',
              label: 'Subtraction_outline',
              src: subtractionOutlineSrc,
            },
            {
              id: 'subtraction_filled',
              label: 'Subtraction',
              src: subtractionFilledSrc,
            },
            {
              id: 'division_outline',
              label: 'Division_outline',
              src: divisionOutlineSrc,
            },
            {
              id: 'division_filled',
              label: 'Division',
              src: divisionFilledSrc,
            },
          ],
        },
        {
          id: 'arrows',
          title: 'Arrows',
          icons: [
            { id: 'arrow_2_up', label: 'Arrow_2_up', src: Arrow2UpSrc },
            { id: 'arrow_2_down', label: 'Arrow_2_down', src: Arrow2DownSrc },
            { id: 'arrow_2_left', label: 'Arrow_2_left', src: Arrow2LeftSrc },
            {
              id: 'arrow_2_right',
              label: 'Arrow_2_right',
              src: Arrow2RightSrc,
            },
            { id: 'arrow_3_up', label: 'Arrow_3_up', src: Arrow3UpSrc },
            { id: 'arrow_3_down', label: 'Arrow_3_down', src: Arrow3DownSrc },
            { id: 'arrow_3_left', label: 'Arrow_3_left', src: Arrow3LeftSrc },
            {
              id: 'arrow_3_right',
              label: 'Arrow_3_right',
              src: Arrow3RightSrc,
            },
            {
              id: 'arrow_3_right_up',
              label: 'Arrow_3_right_up',
              src: Arrow3RightUpSrc,
            },
            {
              id: 'arrow_3_right_down',
              label: 'Arrow_3_right_down',
              src: Arrow3RightDownSrc,
            },
            {
              id: 'arrow_3_left_up',
              label: 'Arrow_3_left_up',
              src: Arrow3LeftUpSrc,
            },
            {
              id: 'arrow_3_left_down',
              label: 'Arrow_3_left_down',
              src: Arrow3LeftDownSrc,
            },
            { id: 'arrows_up', label: 'Arrows_up', src: ArrowsUpSrc },
            { id: 'arrows_down', label: 'Arrows_down', src: ArrowsDownSrc },
            { id: 'arrows_left', label: 'Arrows_left', src: ArrowsLeftSrc },
            { id: 'arrows_right', label: 'Arrows_right', src: ArrowsRightSrc },
            {
              id: 'arrows_up_down',
              label: 'Arrows_up_down',
              src: ArrowsUpDownSrc,
            },
          ],
        },
        {
          id: 'arrow_circles',
          title: 'Arrow Circles',
          icons: [
            {
              id: 'arrow_circle_up',
              label: 'Arrow_circle_up',
              src: ArrowCircleUpSrc,
            },
            {
              id: 'arrow_circle_down',
              label: 'Arrow_circle_down',
              src: ArrowCircleDownSrc,
            },
            {
              id: 'arrow_circle_left',
              label: 'Arrow_circle_left',
              src: ArrowCircleLeftSrc,
            },
            {
              id: 'arrow_circle_right',
              label: 'Arrow_circle_right',
              src: ArrowCircleRightSrc,
            },
            {
              id: 'arrow_circle_top_right',
              label: 'Arrow_circle_top_right',
              src: ArrowCircleTopRightSrc,
            },
            {
              id: 'arrow_circle_bottom_right',
              label: 'Arrow_circle_bottom_right',
              src: ArrowCircleBottomRightSrc,
            },
            {
              id: 'arrow_circle_bottom_left',
              label: 'Arrow_circle_bottom_left',
              src: ArrowCircleBottomLeftSrc,
            },
            {
              id: 'arrow_circle_top_left',
              label: 'Arrow_circle_top_left',
              src: ArrowCircleTopLeftSrc,
            },
          ],
        },
        {
          id: 'navigation',
          title: 'Navigation',
          icons: [
            { id: 'refresh_cw', label: 'Refresh_CW', src: RefreshCwSrc },
            { id: 'refresh_ccw', label: 'Refresh_CCW', src: RefreshCcwSrc },
            { id: 'replace', label: 'Replace', src: ReplaceSrc },
            { id: 'next', label: 'Next', src: NextSrc },
            { id: 'back', label: 'Back', src: BackSrc },
            { id: 'back_2', label: 'Back_2', src: Back2Src },
            { id: 'back_3', label: 'Back_3', src: Back3Src },
            { id: 'next_2', label: 'Next_2', src: Next2Src },
            { id: 'next_3', label: 'Next_3', src: Next3Src },
          ],
        },
        {
          id: 'text_formatting',
          title: 'Text Formatting',
          icons: [
            { id: 'bold', label: 'Bold', src: BoldSrc },
            { id: 'italic', label: 'Italic', src: ItalicSrc },
            { id: 'underline', label: 'Underline', src: UnderlineSrc },
            {
              id: 'strikethrough',
              label: 'Strikethrough',
              src: StrikethroughSrc,
            },
            { id: 'bg_color', label: 'Bg_color', src: BgColorSrc },
            { id: 'text_color', label: 'Text_color', src: TextColorSrc },
            { id: 'link', label: 'Link', src: LinkSrc },
            { id: 'signature', label: 'Signature', src: SignatureSrc },
            { id: 'align_left', label: 'Align_left', src: AlignLeftSrc },
            { id: 'align_right', label: 'Align_right', src: AlignRightSrc },
            { id: 'align_center', label: 'Align_center', src: AlignCenterSrc },
            {
              id: 'align_justify',
              label: 'Align_justify',
              src: AlignJustifySrc,
            },
            { id: 'indent_left', label: 'Indent_left', src: IndentLeftSrc },
            { id: 'indent_right', label: 'Indent_right', src: IndentRightSrc },
            { id: 'refine', label: 'Refine', src: RefineSrc },
            { id: 'write_ai', label: 'Write_ai', src: WriteAiSrc },
            { id: 'ai_wand', label: 'Ai_wand', src: AiWandSrc },
            { id: 'variable', label: 'Variable', src: VariableSrc },
            { id: 'enumerate', label: 'Enumerate', src: EnumerateSrc },
            { id: 'list', label: 'List', src: ListSrc },
            { id: 'blockquote', label: 'Blockquote', src: BlockquoteSrc },
            { id: 'emoji_smile', label: 'Emoji_smile', src: EmojiSmileSrc },
          ],
        },
        {
          id: 'status',
          title: 'Status',
          icons: [
            { id: 'info', label: 'Info', src: InfoSrc },
            { id: 'attention', label: 'Attention', src: AttentionSrc },
            { id: 'alert', label: 'Alert', src: AlertSrc },
            { id: 'close', label: 'Close', src: CloseSrc },
            { id: 'checkmark', label: 'Checkmark', src: CheckmarkSrc },
            { id: 'checkmark2', label: 'Checkmark2', src: Checkmark2Src },
            {
              id: 'checkmark2_otl',
              label: 'Checkmark2_otl',
              src: Checkmark2OtlSrc,
            },
            { id: 'check_in', label: 'Check_in', src: CheckInSrc },
            { id: 'check_out', label: 'Check_out', src: CheckOutSrc },
            { id: 'star1', label: 'Star1', src: Star1Src },
            { id: 'star2', label: 'Star2', src: Star2Src },
          ],
        },
        {
          id: 'actions',
          title: 'Actions',
          icons: [
            { id: 'search', label: 'Search', src: SearchSrc },
            { id: 'sort', label: 'Sort', src: SortSrc },
            { id: 'location', label: 'Location', src: LocationSrc },
            { id: 'tweak', label: 'Tweak', src: TweakSrc },
            { id: 'settings', label: 'Settings', src: SettingsSrc },
            { id: 'more1', label: 'More1', src: More1Src },
            { id: 'more2', label: 'More2', src: More2Src },
            { id: 'dot', label: 'Dot', src: DotSrc },
            { id: 'drag', label: 'Drag', src: DragSrc },
            { id: 'delete1', label: 'Delete1', src: Delete1Src },
            { id: 'delete2', label: 'Delete2', src: Delete2Src },
            { id: 'edit', label: 'Edit', src: EditSrc },
            { id: 'copy', label: 'Copy', src: CopySrc },
            { id: 'duplicate', label: 'Duplicate', src: DuplicateSrc },
            { id: 'move_to', label: 'Move_to', src: MoveToSrc },
            {
              id: 'move_to_folder',
              label: 'Move_to_folder',
              src: MoveToFolderSrc,
            },
            {
              id: 'move_to_folder_2',
              label: 'Move_to_folder_2',
              src: MoveToFolder2Src,
            },
            { id: 'print1', label: 'Print1', src: Print1Src },
            { id: 'print2', label: 'Print2', src: Print2Src },
            { id: 'pin', label: 'Pin', src: PinSrc },
            { id: 'download', label: 'Download', src: DownloadSrc },
            { id: 'view', label: 'View', src: ViewSrc },
            { id: 'hide', label: 'Hide', src: HideSrc },
            { id: 'grid', label: 'Grid', src: GridSrc },
            { id: 'camera', label: 'Camera', src: CameraSrc },
          ],
        },
        {
          id: 'communication',
          title: 'Communication',
          icons: [
            {
              id: 'communications',
              label: 'Communications',
              src: CommunicationsSrc,
            },
            { id: 'call', label: 'Call', src: CallSrc },
            { id: 'call_check', label: 'Call_check', src: CallCheckSrc },
            {
              id: 'arrow_missed_call',
              label: 'Arrow_missed_call',
              src: ArrowMissedCallSrc,
            },
            {
              id: 'arrow_declined',
              label: 'Arrow_declined',
              src: ArrowDeclinedSrc,
            },
            { id: 'message', label: 'Message', src: MessageSrc },
            { id: 'fax', label: 'Fax', src: FaxSrc },
            { id: 'inbox', label: 'Inbox', src: InboxSrc },
            { id: 'archive', label: 'Archive', src: ArchiveSrc },
            { id: 'attachment', label: 'Attachment', src: AttachmentSrc },
            { id: 'sent', label: 'Sent', src: SentSrc },
            { id: 'send', label: 'Send', src: SendSrc },
            {
              id: 'send_in_advance',
              label: 'Send_in_advance',
              src: SendInAdvanceSrc,
            },
            {
              id: 'send_in_advance_2',
              label: 'Send_in_advance_2',
              src: SendInAdvance2Src,
            },
            { id: 'mail_fill', label: 'Mail_fill', src: MailFillSrc },
            { id: 'mail_line', label: 'Mail_line', src: MailLineSrc },
            {
              id: 'mail_open_fill',
              label: 'Mail_open_fill',
              src: MailOpenFillSrc,
            },
            {
              id: 'mail_open_line',
              label: 'Mail_open_line',
              src: MailOpenLineSrc,
            },
            { id: 'blocked', label: 'Blocked', src: BlockedSrc },
            { id: 'drafts', label: 'Drafts', src: DraftsSrc },
            { id: 'folder', label: 'Folder', src: FolderSrc },
            { id: 'tag', label: 'Tag', src: TagSrc },
            {
              id: 'notifications',
              label: 'Notifications',
              src: NotificationsSrc,
            },
          ],
        },
        {
          id: 'audio',
          title: 'Audio',
          icons: [
            { id: 'record', label: 'Record', src: RecordSrc },
            {
              id: 'audio_player_play',
              label: 'Audio_player_play',
              src: AudioPlayerPlaySrc,
            },
            {
              id: 'audio_player_pause',
              label: 'Audio_player_pause',
              src: AudioPlayerPauseSrc,
            },
            {
              id: 'audio_player_play_2',
              label: 'Audio_player_play_2',
              src: AudioPlayerPlay2Src,
            },
            {
              id: 'audio_player_pause_2',
              label: 'Audio_player_pause_2',
              src: AudioPlayerPause2Src,
            },
            {
              id: 'audio_player_back_10',
              label: 'Audio_player_back_10',
              src: AudioPlayerBack10Src,
            },
            {
              id: 'audio_player_forward_10',
              label: 'Audio_player_forward_10',
              src: AudioPlayerForward10Src,
            },
            {
              id: 'audio_player_volume',
              label: 'Audio_player_volume',
              src: AudioPlayerVolumeSrc,
            },
            {
              id: 'audio_player_volume_mute',
              label: 'Audio_player_volume_mute',
              src: AudioPlayerVolumeMuteSrc,
            },
          ],
        },
        {
          id: 'medical',
          title: 'Medical',
          icons: [
            { id: 'in_treatment', label: 'In_treatment', src: InTreatmentSrc },
            {
              id: 'in_treatment_ai',
              label: 'In_treatment_ai',
              src: InTreatmentAiSrc,
            },
            { id: 'intreatment2', label: 'InTreatment2', src: InTreatment2Src },
            { id: 'stethoscope', label: 'Stethoscope', src: StethoscopeSrc },
            {
              id: 'health_condition',
              label: 'Health_condition',
              src: HealthConditionSrc,
            },
            { id: 'allergies', label: 'Allergies', src: AllergiesSrc },
            { id: 'health', label: 'Health', src: HealthSrc },
            {
              id: 'medical_test',
              label: 'Medical_test',
              src: MedicalTestSrc,
            },
            { id: 'lab', label: 'Lab', src: LabSrc },
            { id: 'health_test', label: 'Health_test', src: HealthTestSrc },
            {
              id: 'attention_required',
              label: 'Attention_required',
              src: AttentionRequiredSrc,
            },
          ],
        },
        {
          id: 'finance',
          title: 'Finance',
          icons: [
            { id: 'money', label: 'Money', src: MoneySrc },
            { id: 'money2', label: 'Money2', src: Money2Src },
            { id: 'dollar', label: 'Dollar', src: DollarSrc },
            {
              id: 'adjustment',
              label: 'Adjustment',
              src: AdjustmentSrc,
            },
            { id: 'claims', label: 'Claims', src: ClaimsSrc },
            { id: 'wallet', label: 'Wallet', src: WalletSrc },
            { id: 'collect1', label: 'Collect1', src: Collect1Src },
            { id: 'collect2', label: 'Collect2', src: Collect2Src },
            {
              id: 'missed_payments',
              label: 'Missed_payments',
              src: MissedPaymentsSrc,
            },
            {
              id: 'recurring',
              label: 'Recurring',
              src: RecurringSrc,
            },
          ],
        },
        {
          id: 'insurance',
          title: 'Insurance',
          icons: [
            {
              id: 'insurance_module',
              label: 'Insurance_module',
              src: InsuranceModuleSrc,
            },
            { id: 'shield', label: 'Shield', src: ShieldSrc },
            {
              id: 'shield_outline',
              label: 'Shield_outline',
              src: ShieldOutlineSrc,
            },
            {
              id: 'insurance_verified',
              label: 'Insurance_verified',
              src: InsuranceVerifiedSrc,
            },
            {
              id: 'insurance_plus',
              label: 'Insurance_plus',
              src: InsurancePlusSrc,
            },
            {
              id: 'insurance_unverified',
              label: 'Insurance_unverified',
              src: InsuranceUnverifiedSrc,
            },
            {
              id: 'insurance_expired',
              label: 'Insurance_expired',
              src: InsuranceExpiredSrc,
            },
            {
              id: 'insurance_info',
              label: 'Insurance_info',
              src: InsuranceInfoSrc,
            },
          ],
        },
        {
          id: 'people',
          title: 'People',
          icons: [
            { id: 'staff', label: 'Staff', src: StaffSrc },
            { id: 'user_avatar', label: 'User_avatar', src: UserAvatarSrc },
            {
              id: 'avatar_clock',
              label: 'Avatar_clock',
              src: AvatarClockSrc,
            },
            {
              id: 'avatar_user_info',
              label: 'Avatar_user_info',
              src: AvatarUserInfoSrc,
            },
            {
              id: 'add_user_avatar',
              label: 'Add_user_avatar',
              src: AddUserAvatarSrc,
            },
            {
              id: 'add_group_avatar',
              label: 'Add_group_avatar',
              src: AddGroupAvatarSrc,
            },
            { id: 'male', label: 'Male', src: MaleSrc },
            { id: 'female', label: 'Female', src: FemaleSrc },
            { id: 'attendance', label: 'Attendance', src: AttendanceSrc },
            {
              id: 'avatar_blocked',
              label: 'Avatar_blocked',
              src: AvatarBlockedSrc,
            },
            { id: 'patient_info', label: 'Patient_info', src: PatientInfoSrc },
          ],
        },
        {
          id: 'documents',
          title: 'Documents',
          icons: [
            { id: 'file', label: 'File', src: FileSrc },
            { id: 'document', label: 'Document', src: DocumentSrc },
            { id: 'document2', label: 'Document2', src: Document2Src },
            { id: 'files', label: 'Files', src: FilesSrc },
            { id: 'file_2', label: 'File_2', src: File2Src },
            { id: 'files_pdf', label: 'Files_pdf', src: FilesPdfSrc },
            {
              id: 'files_letters',
              label: 'Files_letters',
              src: FilesLettersSrc,
            },
            { id: 'notes', label: 'Notes', src: NotesSrc },
            { id: 'charting', label: 'Charting', src: ChartingSrc },
            { id: 'image_viewer', label: 'Image_viewer', src: ImageViewerSrc },
            {
              id: 'form_builder',
              label: 'Form_builder',
              src: FormBuilderSrc,
            },
            {
              id: 'form_completed',
              label: 'Form_completed',
              src: FormCompletedSrc,
            },
            {
              id: 'form_incomplete',
              label: 'Form_incomplete',
              src: FormIncompleteSrc,
            },
            { id: 'tx_plan', label: 'Tx_plan', src: TxPlanSrc },
            { id: 'tx_plan2', label: 'Tx_plan2', src: TxPlan2Src },
            { id: 'billing', label: 'Billing', src: BillingSrc },
            { id: 'membership', label: 'Membership', src: MembershipSrc },
            { id: 'reporting', label: 'Reporting', src: ReportingSrc },
            { id: 'campaign', label: 'Campaign', src: CampaignSrc },
            // Inline SVG: <img src="…Dashboard…"> is often blocked by ad blockers.
            { id: 'dashboard', label: 'Dashboard', Icon: DashboardIcon },
          ],
        },
        {
          id: 'time',
          title: 'Time',
          icons: [
            { id: 'clock', label: 'Clock', src: ClockSrc },
            { id: 'clock2', label: 'Clock2', src: Clock2Src },
            { id: 'history', label: 'History', src: HistorySrc },
            { id: 'request', label: 'Request', src: RequestSrc },
          ],
        },
        {
          id: 'calendar',
          title: 'Schedule',
          icons: [
            { id: 'add_schedule', label: 'Add_schedule', src: AddScheduleSrc },
            { id: 'schedule', label: 'Schedule', src: ScheduleSrc },
            { id: 'schedule2', label: 'Schedule2', src: Schedule2Src },
            { id: 'scheduler', label: 'Scheduler', src: SchedulerSrc },
            {
              id: 'previous_calendar',
              label: 'Previous_calendar',
              src: PreviousCalendarSrc,
            },
            {
              id: 'upcoming_calendar',
              label: 'Upcoming_calendar',
              src: UpcomingCalendarSrc,
            },
            { id: 'calendar', label: 'Calendar', src: CalendarSrc },
            {
              id: 'add_schedule_otl',
              label: 'Add_schedule_otl',
              src: AddScheduleOtlSrc,
            },
            { id: 'schedule_otl', label: 'Schedule_otl', src: ScheduleOtlSrc },
            {
              id: 'previous_calendar_otl',
              label: 'Previous_calendar_otl',
              src: PreviousCalendarOtlSrc,
            },
            {
              id: 'upcoming_calendar_otl',
              label: 'Upcoming_calendar_otl',
              src: UpcomingCalendarOtlSrc,
            },
            { id: 'calendar_otl', label: 'Calendar_otl', src: CalendarOtlSrc },
          ],
        },
      ].map((group) => (
        <section key={group.id} className="icons-showcase__group">
          <h4 className="icons-showcase__group-title">{group.title}</h4>
          <div className="icons-showcase__group-row">
            {group.icons.map((icon: IconShowcaseEntry) => {
              const InlineIcon = icon.Icon
              return (
                <div key={icon.id} className="icons-showcase__card">
                  <div className="icons-showcase__swatch">
                    {InlineIcon ? (
                      <InlineIcon aria-hidden="true" width={40} height={40} />
                    ) : (
                      <img
                        src={icon.src}
                        alt={icon.label}
                        width={40}
                        height={40}
                      />
                    )}
                  </div>
                  <p className="icons-showcase__label">{icon.label}</p>
                </div>
              )
            })}
          </div>
        </section>
      ))}
    </div>
  </UiPreviewCanvas>
)

export default IconsShowcase
